import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { SafeUrl } from '@angular/platform-browser';
import { HeroVideoInterface } from '../../../@core/models/site-material-data.model';
import * as Sentry from "@sentry/browser";
import { SafePipe } from '../../../@core/pipes/safe.pipe';
import { DataService } from 'src/app/@core/services/data.service';
import { FontsService } from 'src/app/@core/services/fonts.service';



@Component({
  selector: 'app-hero-video',
  templateUrl: './hero-video.component.html',
  styleUrls: ['./hero-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialHeroVideoComponent implements OnInit {

  title: string;
  text: string;
  video: string;
  videoPosition: string;
  textAlign: string;
  safeVideo: SafeUrl;
  titleColor: string = '';
  textColor: string = '';
  fontWeight: string = '';
  titleFontFamily: string = '';
  titleFontFamilyName: string = '';
  activatePadding: boolean = false;
  backgroundColor: string;
  videoWidth: string | number;
  videoHeight: string | number;
  videoSource: string = '';
  buttonText: string = 'Get Started';
  buttonLink: string;
  titleSize: string;
  textSize: string;
  subscription: Subscription;
  data: HeroVideoInterface;
  position: number = 0;
  moduleInfo: string;
  allElementAnimation: string;
  textAnimation: string;
  videoAnimation: string;
  displayVideo: boolean = false;
  loading: boolean = true;
  image: string = '';
  style$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(private safePipe: SafePipe,private fontsService: FontsService, private dataService: DataService) {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "HeroVideoComponent");
    });
  }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.videoAnimation = this.data.animation.video != '' ? this.data.animation.video : undefined;

    }
    this.loading = false;
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.title = this.data.title;
    this.text = this.data.text;
    this.video = this.data.video;
    this.videoSource = this.data.source;
    this.videoWidth = this.data.width;
    this.videoHeight = this.data.height;
    this.buttonLink = this.data.buttonLink;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.textSize = this.data.textSize;
    this.textColor = this.data.textColor;
    this.fontWeight = this.data.fontWeight;
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    this.videoPosition = this.data.videoPosition ? this.data.videoPosition : 'center';
    this.textAlign = this.data.textAlign ? this.data.textAlign : 'center';
    this.safeVideo = this.safePipe.transform(this.video, 'resourceUrl');
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.image = this.data.image;
    this.style$.next(`url("${this.image}")`);
    this.displayVideo = this.image ? false : true;
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.data.textColor;
    this.textColor = this.data.textColor ? this.data.textColor : this.dataService.getDefaultColor(this.backgroundColor);
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
  }
  changeDisplayVideo() {
    this.displayVideo = true;
  }
}
